import Vue from 'vue'
import {
  Button,
  Select,
  Input,
  Row,
  Col,
  Image,
  Tabs,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Card,
  Pagination,
  Tooltip,
  Dialog,
  Form,
  FormItem,
  InfiniteScroll,
  MessageBox,
  Message,
  Table,
  TableColumn,
  Carousel,
  CarouselItem,
  Cascader,
  DatePicker,
  Option,
  TimePicker,
  Switch,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Upload,
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
Vue.use(Button)
Vue.use(Select)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(InfiniteScroll)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(Option)
Vue.use(TimePicker)
Vue.use(Switch)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Upload)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
